'use es6';

import getComponentName from 'react-utils/getComponentName';
/**
 * @param {ReactElement} node
 * @param {RegExp} regex
 * @returns {Boolean} - true if the node has a displayName that matches the given regex
 */

export const nodeDisplayNameMatches = (node, regex) => !!(node && getComponentName(node.type).match(regex));